import api from "../../api";
import { setDeeplinkData, setDeeplinkLoading } from "./deeplink-actions";

export const checkPendingDeeplink = () => async (dispatch) => {
  try {
    dispatch(setDeeplinkLoading(true));
    const data = await api.deeplink.checkPending();
    if (data.has_pending) {
      dispatch(setDeeplinkData(data.data));
    }
  } catch (error) {
    console.error("Error checking pending deeplink:", error);
  } finally {
    dispatch(setDeeplinkLoading(false));
  }
};

export const clearPendingDeeplink = () => async (dispatch) => {
  try {
    await api.deeplink.clearPending();
    dispatch(setDeeplinkData(null)); // Clear deeplink data from store
  } catch (error) {
    console.error("Error clearing pending deeplink:", error);
  }
};